// src/pages/plantation/monitor-setara-urea-per-umur/FilterChipStylesMonitorSetaraUrea.js
export const chipStyles = {
  // Style dasar untuk semua chip
  base: {
    height: 36,
    borderRadius: 2,
    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.1), 0px 1px 1px 0px rgba(0, 0, 0, 0.07), 0px 1px 3px 0px rgba(0, 0, 0, 0.06)',
    "& .MuiChip-label": {
      px: 2,
      py: 1.5,
      fontWeight: 500,
    },
    "& .MuiChip-icon": {
      ml: 1.5,
    },
    "& .MuiChip-deleteIcon": {
      mr: 1,
    },
    "&:hover": {
      boxShadow: "0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",
    },
  },
  
  // Style untuk chip filter yang belum dipilih
  default: {
    backgroundColor: "background.paper",
    "& .MuiChip-label": {
      color: "text.primary",
    },
    "& .MuiChip-icon": {
      color: "primary.main",
    },
    "& .MuiChip-deleteIcon": {
      color: "text.secondary",
    },
    "&:hover": {
      backgroundColor: "#f2f9ff",
    },
  },
  
  // Style untuk chip filter yang sudah dipilih
  selected: {
    backgroundColor: "primary.main",
    "& .MuiChip-label": {
      color: "white",
    },
    "& .MuiChip-icon": {
      color: "white",
    },
    "& .MuiChip-deleteIcon": {
      color: "white",
    },
    "&:hover": {
      backgroundColor: "#0288d1",
    },
  },
  
  // Style khusus untuk reset filter chip
  reset: {
    backgroundColor: 'warning.main',
    color: 'white',
    "& .MuiChip-label": {
      color: 'white',
    },
    "& .MuiChip-icon": {
      color: 'white',
    },
    "&:hover": {
      backgroundColor: 'warning.dark',
    },
  },
};

// Fungsi helper untuk mendapatkan style chip filter berdasarkan kondisi
export const getFilterChipStyles = (isSelected, paperShadow) => ({
  ...chipStyles.base,
  ...(isSelected ? chipStyles.selected : chipStyles.default),
  boxShadow: paperShadow,
});

// Fungsi untuk mendapatkan style chip reset filter
export const getResetChipStyles = (paperShadow) => ({
  ...chipStyles.base,
  ...chipStyles.reset,
  boxShadow: paperShadow,
});